module.exports = __webpack_public_path__ + "img/reviews-author-14.667bf0b.jpg";